import React from 'react';
import classNames from 'classnames';
import dragula from 'react-dragula';
import update from 'immutability-helper';

import Card from 'components/Card';
import Icon from 'components/Icon';
import Modal from 'components/Modal';
import ModalButton from 'components/ModalButton';
import ModalHeader from 'components/ModalHeader';

import { MODALS } from 'utils/constants';
import { ASSIGNMENT_STATES } from './../constants';

export default class AssignmentContentsReviewModal extends React.Component {
    constructor() {
        super();
        this.cardsDragging = null;
    }

    componentDidUpdate() {
        setTimeout(() => {
            if(this.props.assignment.state === ASSIGNMENT_STATES.UNPUBLISHED) {
                this.startReordering();
            }
        }, 1);
    }

    startReordering() {
        if(this.cardsDragging == null && this.props.modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_REVIEW) {
            let cardsList = document.querySelector('.assignment-contents-review .cards');
            if(cardsList != null) {
                this.cardsDragging = dragula([cardsList], {
                    moves: (el, container, handle) => {
                        return true;
                    }
                });

                this.cardsDragging.on('drop', (el, target, source, sibling) => {
                    this._handleSaveContentList();
                });
            }
        }
    }

    _handleSaveContentList() {
        let contents = this.props.assignment.contents;
        let cards = Array.prototype.slice.call(document.querySelectorAll('.assignment-review .card:not(.empty)'));
        let ids = cards.map((el) => {
            return parseInt(el.getAttribute('data-id'), 10);
        });
        let newContents = [];
        ids.forEach((id) => {
            for(var i = 0, l = contents.length; i < l; i++) {
                if(id === contents[i].id) {
                    newContents.push(contents[i]);
                    break;
                }
            }
        });
        let newAssignmentObj = update(this.props.assignment, {
            contents: {$set: newContents}
        });
        this.props.setAssignment(newAssignmentObj);
    }

    _handleAddContent() {
        this.cardsDragging = null;
        this.props.openSelectionModal();
    }

    _handleDone() {
        this.cardsDragging = null;
        this.props.reviewConfirm();
    }

    render() {
        let { assignment, closeModal, modalThatIsOpen, removeContentPiece, openModal, reviewCancel, show} = this.props;

        if(Object.keys(assignment).length > 0) {
            return (
                <Modal show={show}
                       className={classNames('assignment-contents-review assignment-contents-list',
                           {
                               'assignment-list': modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_LIST,
                               'assignment-review': modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_REVIEW,
                               'assignment-is-published': assignment.state === ASSIGNMENT_STATES.PUBLISHED,
                               'draggable-parent': assignment.state === ASSIGNMENT_STATES.UNPUBLISHED && modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_REVIEW
                           })}
                       handleClose={closeModal.bind(this)}
                       width={modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_LIST ? 'full' : null}>
                    <ModalHeader>
                        Review Content
                    </ModalHeader>
                    {modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_REVIEW ? (
                        <div role="button"
                             className="review-modal__add details-modal__info"
                             onClick={this._handleAddContent.bind(this)}>
                            <Icon icon="plus" /> Add Content
                        </div>
                    ) : null}

                    {assignment.contents != null && assignment.contents.length > 0 ? (
                        <div className="cards">
                            {assignment.contents.map((content, index) => {
                                if(content != null) {
                                    let contentItem = JSON.parse(JSON.stringify(content));
                                    contentItem.name = `${index + 1}. ${contentItem.name}`;
                                    return <Card item={contentItem}
                                                 className={`${modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_REVIEW ? 'card--narrow' : ''}`}
                                                 onClick={removeContentPiece.bind(this, content, 'contents')}
                                                 type="content--review"
                                                 key={content.id}/>
                                } else {
                                    return null;
                                }
                            })}
                            <div className="card empty"></div>
                            <div className="card empty"></div>
                            <div className="card empty"></div>
                        </div>
                    ) : (
                        <div className="no-cards">
                            No content items added to this assignment.
                        </div>
                    )}

                    {modalThatIsOpen === MODALS.ASSIGNMENT_CONTENT_REVIEW ? (
                        <div className="modal__buttons">
                            <ModalButton icon="check"
                                         onClick={this._handleDone.bind(this)}
                                         text="Done" />
                            <ModalButton className="modal-button--cancel"
                                         icon="cancel"
                                         onClick={() => {
                                             this.cardsDragging = null;
                                             reviewCancel();
                                         }}
                                         text="Cancel" />
                        </div>
                    ) : (
                        <div className="modal__buttons">
                            <ModalButton icon="check"
                                         onClick={openModal.bind(this, MODALS.ASSIGNMENT_DETAILS)}
                                         text="Done"/>
                        </div>
                    )}

                </Modal>
            );
        } else {
            return null;
        }
    }
};



// WEBPACK FOOTER //
// ./src/containers/AssignmentsPage/modals/AssignmentContentsReviewModal.js